import { render, staticRenderFns } from "./EducationModal.vue?vue&type=template&id=631c42fa"
import script from "./EducationModal.vue?vue&type=script&lang=ts"
export * from "./EducationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631c42fa')) {
      api.createRecord('631c42fa', component.options)
    } else {
      api.reload('631c42fa', component.options)
    }
    module.hot.accept("./EducationModal.vue?vue&type=template&id=631c42fa", function () {
      api.rerender('631c42fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/EducationModal.vue"
export default component.exports